// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__ikk4k","divider__container":"Divider_divider__container__83BZ2","divider__title":"Divider_divider__title__nPQpv"};